import { Routes, Route, Link, NavLink, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Hub } from "aws-amplify/utils";
import { Feed } from "./routes/Feed";
import { PostDetail } from "./routes/PostDetail";
import { Submit } from "./routes/Submit";
import { Profile } from "./routes/Profile";
import { Login } from "./routes/Login";
import { AuthCallback } from "./routes/AuthCallback";
import { currentUser, logout } from "./lib/auth";

export function App() {
  const [user, setUser] = useState<{ username: string } | null>(null);

  useEffect(() => {
    currentUser().then(setUser);

    const unsub = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signedIn":
        case "tokenRefresh":
          currentUser().then(setUser);
          break;
        case "signedOut":
          setUser(null);
          break;
      }
    });

    return unsub;
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-30 backdrop-blur bg-ink-950/70 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="grid place-items-center h-7 w-7 rounded-lg bg-gradient-to-br from-accent to-accent-deep text-white font-bold shadow-glow">
              P
            </span>
            <span className="text-white font-semibold tracking-tight group-hover:text-accent-soft transition-colors">
              peerbl
            </span>
          </Link>
          <nav className="flex items-center gap-1 ml-2">
            <NavItem to="/" label="feed" end />
            <NavItem to="/submit" label="submit" />
            <NavItem to="/me" label="profile" />
          </nav>
          <div className="ml-auto flex items-center gap-3">
            {user ? (
              <>
                <Link
                  to="/me"
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  {user.username}
                </Link>
                <button onClick={() => logout()} className="btn-ghost">
                  sign out
                </button>
              </>
            ) : (
              <Link to="/login" className="btn-ghost">
                sign in
              </Link>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1 w-full max-w-3xl mx-auto px-4 py-6 animate-fade-in">
        <Routes>
          <Route path="/" element={<Feed />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/me" element={<Profile />} />
          <Route path="/u/:username" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <footer className="border-t border-white/5 py-6 text-center text-xs text-mute">
        peerbl · built on AWS ·{" "}
        <a href="https://github.com" className="hover:text-white">
          source
        </a>
      </footer>
    </div>
  );
}

function NavItem({
  to,
  label,
  end,
}: {
  to: string;
  label: string;
  end?: boolean;
}) {
  return (
    <NavLink
      to={to}
      end={end ?? false}
      className={({ isActive }) =>
        `px-3 py-1.5 rounded-lg text-sm transition-colors ${
          isActive
            ? "text-white bg-white/5"
            : "text-mute hover:text-white hover:bg-white/5"
        }`
      }
    >
      {label}
    </NavLink>
  );
}
